import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";

import "./hover-anim.css";

export const HoverAnimButton = ({navTo, icon,caption, path}) => {
    return (
        <div className='button-box'>
            <button 
                className={classNames('hover-button',{'act': path })} 
                onClick={navTo}
            >
               <FontAwesomeIcon icon={icon} className="hv-2" />
                <span className={classNames("cap", "sm", "nav-caption")}>{caption}</span>
            </button>
            <div className='hover-bg'/>
        </div>
    )
}